$("#owl-home").owlCarousel({

      navigation : true, // Show next and prev buttons
      nav:true,
      navText: ["<span class='icon-NAV_left'></span>","<span class='icon-NAV_right'></span>"],
      slideSpeed : 300,
      paginationSpeed : 400,

      items : 1,
      itemsDesktop : false,
      itemsDesktopSmall : false,
      itemsTablet: false,
      itemsMobile : false,

  });

//tooltip shows title on hover
$(function () {
  $('[data-toggle="tooltip"]').tooltip();
})

//expand icon rotation
$(".rotate").on('mouseup', function () {
    $(this).toggleClass("down");
})

$(document).ready(function () {

  $('.navbar-toggler').on('click', function () {

    $('.navIcon').toggleClass('open');
  });

});


$(document).ready(function(){

  //Lire la suite
  $('.read-more').click(function(e) {
    e.preventDefault();
    $(this).text(function(i, t) {
      // return t == 'fermer' ? 'lire la suite ›' : 'fermer';
      return t;
    }).prev('.read-more-content').toggle()
  });


  if ($(window).width() < 960) {
     $('.navbar').addClass('fixed-top');
  }
 else {
   $('.navbar').removeClass('fixed-top');
 }

  var scrollTop = 0;

  $(window).scroll(function(){
    scrollTop = $(window).scrollTop();

    if (scrollTop >= 100) {
      $('#global-nav').addClass('scrolled-nav');
      $('.nav-scroller').addClass('nav-scroller-up');
      $('.nav-header-logo').css("display","none");
      $('.nav-header-logo-scroller').css("display","block");
    } else if (scrollTop < 100) {
      $('#global-nav').removeClass('scrolled-nav');
      $('.nav-scroller').removeClass('nav-scroller-up');
      $('.nav-header-logo').css("display","block");
      $('.nav-header-logo-scroller').css("display","none");
    }
  });

});


$(window).resize(function() {
  if ($(window).width() < 960) {
     $('.navbar').addClass('fixed-top');
  }
 else {
   $('.navbar').removeClass('fixed-top');
 }
});


$('.owl-same-category.owl-carousel').owlCarousel({
    loop:true,
    margin:10,
    nav:true,
    items: 3,
    dotsEach: 3,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:2
        },
        1000:{
            items:3
        }
    },
    nav: true,
    navText: ["<span class='icon-NAV_left'></span>","<span class='icon-NAV_right'></span>"]
})

$('.owl-prefooter.owl-carousel').owlCarousel({
    loop:true,
    margin:10,
    nav:true,
    dots: false,
    items: 6,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:3
        },
        1000:{
            items:6
        }
    },
    nav: true,
    navText: ["<span class='icon-NAV_left'></span>","<span class='icon-NAV_right'></span>"]
})


$('#pagination-nav').twbsPagination({
    totalPages: 16,
    visiblePages: 3,
    first: '‹‹',
    next: '›',
    prev: '‹',
    last: '››',
    onPageClick: function (event, page) {
        //fetch content and render here
        $('#page-content').text('Page ' + page) + ' content here';
    }
});


// The function actually applying the offset
function offsetAnchor() {
  if (location.hash.length !== 0) {
    window.scrollTo(window.scrollX, window.scrollY - 110);
  }
}

// Captures click events of all <a> elements with href starting with #
$(document).on('click', 'a[href="#ONEAVRS"]', function(event) {
  // Click events are captured before hashchanges. Timeout
  // causes offsetAnchor to be called after the page jump.
  window.setTimeout(function() {
    offsetAnchor();
  }, 0);
});

// Set the offset when entering page with hash present in the url
window.setTimeout(offsetAnchor, 0);
